const initialState = {
    msgBar: [],
    gmailAddOnMsgBar:[],
    msgCommentBar: [],
	msgSharingDetailsBar: []
};

const msgBarReducer = (state = initialState, action ) => {
    switch (action.type) {
        case "MSG_BAR":
            state = {
                ...state,
                msgBar: action.payload
            };
            break;
        case "GMAIL_ADDON_MSG_BAR":
            state = {
                ...state,
                gmailAddOnMsgBar: action.payload
            };
            break;
        case "MSG_COMMENT_BAR":
            state = {
                ...state,
                msgCommentBar: action.payload
            };
            break;
	    case "MSG_SHARING_DETAILS_BAR":
		    state = {
			    ...state,
			    msgSharingDetailsBar: action.payload
		    };
		    break;
        default :
            break;
    }
    return state;
};

export default msgBarReducer;